<template>
  <div id="cup_teamDetail" v-show="currThemeObj">
    <div class="abs_top">
      <div class="team_infor">
        <span class="teamLogo">
          <img :src="teamBaseInfor.teamLogo" />
        </span>
        <span class="teamName" v-text="teamBaseInfor.teamName"></span>
      </div>
      <div class="selectTab_area">
        <selectTab
          :currThemeObj="currThemeObj"
          :tabArr="tabArr"
          :pageJumpParams="selectTab_pageJumpParams"
          @clickTabEvent="onChangeTab"
        ></selectTab>
      </div>
    </div>
    <div>
      <router-view
        :axiosBaseUrl="axiosBaseUrl"
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :curTimeZoneItem="curTimeZoneItem"
      ></router-view>
    </div>
  </div>
</template>

<script>
import selectTab from '@components/platfromBase/compreSportsMeet/selectTab.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'

export default {
  name: 'cup_teamDetail',
  components: { selectTab },
  mixins: [cup_base_data_mixin],
  data() {
    return {
      teamBaseInfor: {
        teamName: '',
        teamLogo: '',
        teamId: '',
      },
      tabArr: [
        {
          name: '数据',
          id: 'teamData',
          pathName: 'teamDetailTeamData',
          act: true,
        },
        {
          name: '名单',
          id: 'playerList',
          pathName: 'teamDetailPlayerList',
          act: false,
        },
        {
          name: '比赛记录',
          id: 'matchRecord',
          pathName: 'teamDetailMatchRecord',
          act: false,
        },
      ],
      selectTab_pageJumpParams: [],
    }
  },
  created() {
    const mixtmt_teamDetail = this.$localStorage.getItem('mixtmt_teamDetail')
    this.teamBaseInfor = mixtmt_teamDetail
      ? JSON.parse(mixtmt_teamDetail)
      : {
          teamName: '',
          teamLogo: '',
          teamId: '',
        }
    if (this.currThemeObj) {
      this.tabArr.forEach((item) => {
        item.pathName = `${item.pathName}_${this.currThemeObj.moduleRouteNameEn}` // teamDetailPlayerList_FIFAWC
      })
    }
    const query = this.$route.query
    this.selectTab_pageJumpParams = [query, null]
  },
  computed: {},
  methods: {
    onChangeTab(item) {
      this.tabArr.forEach((tabItem) => {
        if (item.id == tabItem.id) {
          tabItem.act = true
        } else {
          tabItem.act = false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
#cup_teamDetail {
  padding-top: 12.36vw;
  .abs_top {
    position: absolute;
    top: 8vw;
    left: 0;
    z-index: 10;
    padding: 0 9.722vw;
    width: 100%;
    height: 12.36vw;
    color: var(--mixtmt_whiteColor);
    background-image: var(--mixtmt_scheduleDetail_banner);
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;
    object-fit: contain;
    .team_infor {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      padding-top: 2.778vw;
      width: 100%;
      height: auto;
      .teamLogo {
        width: 4.16vw;
        height: 4.16vw;
        /* border: 0.281vw solid var(--mixtmt_greyColor9); */
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .teamName {
        padding: 0 1.388vw;
        font-size: 2.083vw;
        font-weight: bold;
        color: var(--mixtmt_whiteColor);
      }
    }
    .selectTab_area {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 10;
      padding: 0 9.722vw;
      width: 100%;
      height: 2.778vw;
    }
  }
}
</style>
